import React from 'react';
import {withNamespaces} from "react-i18next";
import {Button} from "../../../shared/ui/components/Buttons";

const Newsletter = ({ onSubmit, inputRef, isFetching, success, error, t }) =>
    <div className="container">

        <div className="row">
            <div className="col-md-3">
                <img className="mailbox-icon" src="/assets/img/icons/icon-mailbox.png" />
            </div>
            <div className="col-md-8">
                <h2 className="title">L'actu rando <span className="sub">dans votre boite mail</span></h2>
                <p className="part-intro">
                    Abonnez-vous à notre newsletter pour recevoir chaque mois (vous voyez, on ne va pas vous spammer !)
                    les dernières actus de La Malle et des inspirations pour vos prochaines randos !
                </p>
                <form onSubmit={onSubmit}>
                    <div className="form-group row">
                        <div className="col-sm-6">
                            <label htmlFor="inputEmail" className="sr-only">adresse email</label>
                            <input disabled={isFetching} ref={inputRef} type="email" className="form-control" id="inputEmail" placeholder="Votre adresse e-mail" />
                        </div>
                        <div className="col-sm-4">
                            <Button
                                type="submit"
                                disabled={isFetching}
                                className="btn btn-primary btn-block btn-square"
                            >
                                Je m'abonne
                            </Button>

                        </div>
                    </div>
                    {success && <div>
                        <div className="alert alert-success">
                            Super ! Vous recevrez nos prochaines newsletters à l'adresse <strong>{success}</strong>.</div>
                    </div>}
                    {error && <div>
                        <div className="alert alert-danger">{error}</div>
                    </div>}
                </form>
            </div>
        </div>

    </div>;

export default withNamespaces()(Newsletter);
